module.exports = __webpack_public_path__ + "img/solutions--improving_pulmonary_outcomes.d4583d1b.png";